import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ThumbsDownFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M8 13V3l11 .5 2 9-.5 2.5H14l-.5 5.5-2.5.5-3-8z"
  }), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M10.064 21.351A1 1 0 0011 22c2.252 0 4-1.748 4-4v-2h4c1.16 0 2.015-.566 2.512-1.33a3.27 3.27 0 00.469-2.366l-.004-.017-1.689-7.75C20.098 2.985 18.713 2 17.3 2H5C3.348 2 2 3.348 2 5v6c0 1.652 1.348 3 3 3h2.307l2.757 7.351zM7 12H5c-.548 0-1-.452-1-1V5c0-.548.452-1 1-1h2v8zm2-8h8.3c.568 0 .964.388 1.005.8.004.038.01.076.018.113l1.698 7.79c.047.247-.006.601-.185.877-.153.236-.398.42-.836.42h-5a1 1 0 00-1 1v3c0 .916-.542 1.643-1.345 1.9L9 12.819V4z",
    clipRule: "evenodd"
  }));
}

export default ThumbsDownFill;